import { Icon } from '@iconify/react'

const IssuesBySeverity = ({ data, isLoading, isError }) => {
  if (!data || isLoading || isError) return null

  const severityConfig = {
    critical: { icon: 'mdi:alert-circle', bgColor: 'bg-red-50', textColor: 'text-red-600', label: 'Critical' },
    serious: { icon: 'mdi:alert-circle', bgColor: 'bg-red-50', textColor: 'text-red-600', label: 'Serious' },
    high: { icon: 'mdi:alert', bgColor: 'bg-orange-50', textColor: 'text-orange-600', label: 'High' },
    medium: { icon: 'mdi:information', bgColor: 'bg-yellow-50', textColor: 'text-yellow-600', label: 'Medium' },
    moderate: { icon: 'mdi:information', bgColor: 'bg-yellow-50', textColor: 'text-yellow-600', label: 'Moderate' },
    low: { icon: 'mdi:check-circle', bgColor: 'bg-blue-50', textColor: 'text-blue-600', label: 'Low' },
    minor: { icon: 'mdi:check-circle', bgColor: 'bg-green-50', textColor: 'text-green-600', label: 'Minor' },
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      {/* Header */}
      <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
        <div className="flex items-center gap-2">
          <Icon icon="mdi:alert-octagon" className="text-gray-600 text-xl" />
          <h2 className="text-lg font-semibold text-gray-800">Issues by Severity</h2>
        </div>
      </div>

      {/* Content */}
      <div className="p-4">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {Object.entries(data)
            .filter(([severity]) => severity.toLowerCase() !== 'total')
            .map(([severity, countValue]) => {
              const count = typeof countValue === 'number' ? countValue : 0
              const config = severityConfig[severity.toLowerCase()] || {
                icon: 'mdi:information',
                bgColor: 'bg-gray-50',
                textColor: 'text-gray-600',
                label: severity.charAt(0).toUpperCase() + severity.slice(1),
              }

              return (
                <div key={severity} className="text-center p-4 bg-gray-50 rounded-lg border border-gray-100">
                  <div className={`w-10 h-10 mx-auto mb-2 rounded-lg ${config.bgColor} flex items-center justify-center`}>
                    <Icon icon={config.icon} className={`text-xl ${config.textColor}`} />
                  </div>
                  <div className="text-xl font-bold text-gray-800 mb-0.5">{count.toLocaleString()}</div>
                  <div className="text-xs text-gray-500">{config.label} Issues</div>
                </div>
              )
            })}
        </div>
      </div>
    </div>
  )
}

export default IssuesBySeverity
